export enum CustomerNotificationReadStatus {
  Unread = 1,
  Read = 2,
}
